import { useEffect, useRef } from "react";

// Global editorial motion — a single, breathing grain layer.
// Extremely low opacity, slow drift, monochrome only.
// Respects prefers-reduced-motion. Fixed positioning, GPU accelerated.
export default function BackgroundMotion() {
  const lightRef = useRef(null);

  useEffect(() => {
    const el = lightRef.current;
    if (!el) return;
    const prefersReduced =
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    let raf = null;
    const onScroll = () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        // extremely small scroll drift for the soft "light" layer
        const y = window.scrollY * -0.02;
        el.style.transform = `translate3d(0, ${y}px, 0)`;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none z-0" aria-hidden="true">
      {/* soft breathing light — scroll parallaxed */}
      <div ref={lightRef} className="absolute inset-0 motion-light" />
      {/* editorial grain — always drifting */}
      <div className="absolute inset-0 motion-grain" />
    </div>
  );
}
